import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cbd133fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "industry-info" }
const _hoisted_3 = { class: "stats-container" }
const _hoisted_4 = { class: "stat-card" }
const _hoisted_5 = { class: "stat-label" }
const _hoisted_6 = { class: "stat-value" }
const _hoisted_7 = { class: "stat-card" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "行业内排名", -1))
const _hoisted_9 = { class: "stat-value" }
const _hoisted_10 = {
  key: 0,
  class: "stat-card"
}
const _hoisted_11 = { class: "stat-label" }
const _hoisted_12 = { class: "stat-value" }
const _hoisted_13 = {
  key: 1,
  class: "stat-card"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "行业均值", -1))
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = {
  key: 2,
  class: "stat-card"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stat-label" }, "行业中位数", -1))
const _hoisted_18 = { class: "stat-value" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "list-block" }
const _hoisted_21 = {
  class: "legend-container",
  style: {"display":"flex","justify-content":"center","gap":"30px"}
}
const _hoisted_22 = {
  class: "legend-item",
  style: {"display":"flex","align-items":"center","gap":"8px"}
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"12px","height":"12px","background-color":"#1890ff","border-radius":"2px"} }, null, -1))
const _hoisted_24 = {
  class: "legend-item",
  style: {"display":"flex","align-items":"center","gap":"8px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"12px","height":"12px","background-color":"#FF7F0E","border-radius":"2px"} }, null, -1))
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.spinning
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("span", _hoisted_2, "行业：" + _toDisplayString(_ctx.industryName) + "（共" + _toDisplayString(_ctx.totalCompanies) + "家）", 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.currentMetricLabel), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.formatValue(_ctx.currentCompanyValue)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currentCompanyRank) + "/" + _toDisplayString(_ctx.totalCompanies), 1)
            ]),
            (_ctx.shouldShowTotalAndAvg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, "行业总" + _toDisplayString(_ctx.currentMetricLabel), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.formatValue(_ctx.totalIndustryValue)), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.shouldShowTotalAndAvg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatValue(_ctx.industryAvgValue)), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.shouldShowTotalAndAvg)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.formatValue(_ctx.industryMedianValue)), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          ((_ctx.data || []).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_a_radio_group, {
                    value: _ctx.currentMetric,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentMetric) = $event)),
                    "button-style": "solid",
                    onChange: _ctx.changeMetric
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.metrics, (metric, i) => {
                        return (_openBlock(), _createBlock(_component_a_radio_button, {
                          key: 'metric' + i,
                          value: metric.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(metric.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value", "onChange"]),
                  (_ctx.option)
                    ? (_openBlock(), _createBlock(_component_Charts, {
                        key: 0,
                        id: "NumberofLhlcwzb",
                        option: _ctx.option
                      }, null, 8, ["option"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: _ctx.theme === 'dark' ? 'rgb(215, 215, 223)' : '#4d4d4d', fontSize: '14px', fontWeight: 'bold' })
                      }, "行业下公司市值区间", 4)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("span", {
                        style: _normalizeStyle({ color: _ctx.theme === 'dark' ? 'rgb(215, 215, 223)' : '#4d4d4d', fontSize: '14px', fontWeight: 'bold' })
                      }, "当前公司市值所在区间", 4)
                    ])
                  ])
                ]),
                _createVNode(_component_Table, {
                  data: _ctx.currentData,
                  columns: _ctx.columns,
                  bordered: true,
                  pagination: false,
                  scroll: { x: '100%' },
                  "row-class-name": _ctx.setRowClassName
                }, null, 8, ["data", "columns", "row-class-name"])
              ]))
            : (_openBlock(), _createElementBlock("section", _hoisted_26, [
                _createVNode(_component_Nodata, {
                  nodatadesc: _ctx.itemdata.title
                }, null, 8, ["nodatadesc"])
              ]))
        ])
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}